import { useCallback, useEffect, useState } from 'react'

// Whether the invasion war room lives in the middle column (default) or is
// collapsed into the header chip. Persisted so the choice survives phone tab
// unmounts and sessions, and broadcast so the panel mounts, the header chip
// and the popup's "show full panel" button all agree instantly
// (the `useForecastYears` pattern).
export const BOSS_PANEL_HIDDEN_KEY = 'pg-boss-panel-hidden'
export const BOSS_PANEL_HIDDEN_EVENT = 'pg-boss-panel-hidden-change'

export const readBossPanelHidden = () => {
  try {
    return localStorage.getItem(BOSS_PANEL_HIDDEN_KEY) === '1'
  } catch {
    return false
  }
}

export const writeBossPanelHidden = (hidden: boolean) => {
  try {
    if (hidden) {
      localStorage.setItem(BOSS_PANEL_HIDDEN_KEY, '1')
    } else {
      localStorage.removeItem(BOSS_PANEL_HIDDEN_KEY)
    }
  } catch {
    // Private browsing without storage — the in-memory state still works.
  }
}

export const useBossPanelHidden = (): [boolean, (hidden: boolean) => void] => {
  const [hidden, setHidden] = useState<boolean>(readBossPanelHidden)

  useEffect(() => {
    const onChange = () => setHidden(readBossPanelHidden())
    window.addEventListener(BOSS_PANEL_HIDDEN_EVENT, onChange)
    window.addEventListener('storage', onChange)
    return () => {
      window.removeEventListener(BOSS_PANEL_HIDDEN_EVENT, onChange)
      window.removeEventListener('storage', onChange)
    }
  }, [])

  const set = useCallback((next: boolean) => {
    writeBossPanelHidden(next)
    setHidden(next)
    window.dispatchEvent(new Event(BOSS_PANEL_HIDDEN_EVENT))
  }, [])

  return [hidden, set]
}
